import React, { useEffect, useState } from "react";


import Button from "@material-ui/core/Button";
import { Grid } from "@material-ui/core";

import { useSnackbar } from "notistack";

import {
  getById,
  inativar,
  ativar,
} from "../../../services/formulario/FormularioService";

import FormHeader from "../../../components/shared/form/formHeader";
import FormularioVisualizar from "../../../components/formularios/formularioVisualizar";
import ExcluirFormulario from "../../../components/shared/formulario/excluir";

const VisualizarFormulario = (props) => {
  const id = props.match.params.id;
  const { history } = props;
  const [openExcluir, setOpenExcluir] = useState(false);
  const [dadosFormularioVisualizar, setDadosFormularioVisualizar] =
    useState(null);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    const getDadosFormularioVisualiza = async (id) => {
      await getById(id).then((response) => {
        if (response && response.status === 200) {
          const { data } = response;
          let newData = data;
          newData.campos.sort((a, b) => a.ordemCampo - b.ordemCampo);
          setDadosFormularioVisualizar(newData);
        } else {
          history.push("/formularios");
        }
      });
    };

    getDadosFormularioVisualiza(id);
  }, []);

  const handleAtivar = async (ativo) => {
    try {
      if (ativo) {
        await inativar(id).then((response) => {
          if (response && response.status === 200) {
            const { data } = response;
            setDadosFormularioVisualizar(data);
            enqueueSnackbar("Formulário inativado com sucesso", {
              variant: "success",
            });
          } else if (response && response.status === 400) {
            enqueueSnackbar("Este Formulário já está inativado", {
              variant: "warning",
            });
          }
        });
      } else {
        await ativar(id).then((response) => {
          if (response && response.status === 200) {
            const { data } = response;
            setDadosFormularioVisualizar(data);
            enqueueSnackbar("Formulário ativado com sucesso", {
              variant: "success",
            });
          } else if (response && response.status === 400) {
            enqueueSnackbar("Este Formulário já está ativo", {
              variant: "warning",
            });
          }
        });
      }
    } catch (e) {
      console.log("---- error");
      console.log(e);
      enqueueSnackbar("Error ao Ativar/Desativar", { variant: "error" });
    }
  };

  const ActionButton = () => (
    <Grid
      style={{
        gap: "10px",
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "nowrap",
        justifyContent: "space-between",
      }}
    >
      {dadosFormularioVisualizar && (
        <Button
          variant="contained"
          onClick={() => handleAtivar(dadosFormularioVisualizar.ativo)}
        >
          {dadosFormularioVisualizar.ativo ? "Inativar" : "Ativar"}
        </Button>
      )}

      <Button variant="contained" onClick={() => setOpenExcluir(true)}>
        Excluir
      </Button>

      {!dadosFormularioVisualizar?.existeReuniaoVinculada && (
        <Button
          variant="contained"
          onClick={() =>
            history.push({
              pathname: `/formulario/${dadosFormularioVisualizar.id}/editar`,
            })
          }
        >
          Editar
        </Button>
      )}
    </Grid>
  );

  return (
    <>
      <FormHeader ActionButton={ActionButton} titulo="Visualizar Formulário" />
      <Grid style={{ marginTop: 180, padding: "0 24px" }}>
        {dadosFormularioVisualizar && (
          <FormularioVisualizar
            history={history}
            formularioVisualizar={dadosFormularioVisualizar}
          />
        )}
      </Grid>
      {openExcluir && (
        <ExcluirFormulario
          open={openExcluir}
          onClose={() => setOpenExcluir(false)}
          formulario={dadosFormularioVisualizar}
          afterSubmit={() => history.push("/formularios")}
        />
      )}
    </>
  );
};

export default VisualizarFormulario;
